<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="WoRelease"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ title(mode) }}] WO Creation
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION && header.Status != this.$APPROVAL_STATUS.FULL_RELEASE && header.Status_Closing != this.$APPROVAL_STATUS.CLOSED)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && header && header.Status_Closing != this.$APPROVAL_STATUS.CLOSED && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />

                        <Button icon="pi pi-upload" label="Update Tick Print" class="p-button-secondary mr-2" @click="confirmUpdateDetail($event)" v-if="mode == this.$FORM_MODE_VIEW && header && header.Is_Additional" />
                        
                        <Button icon="pi pi-upload" label="Update Status" class="p-button-success mr-2" @click="confirmUpdateWo($event)" v-if="(header && header.Status_Closing == this.$APPROVAL_STATUS.CLOSED) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && this.$store.getters.getIsUpdateWo" />
                        <Button icon="pi pi-file-pdf p-button-icon" v-show="mode == this.$FORM_MODE_VIEW" class="p-button p-component p-button-icon-only p-button-rounded p-button-danger p-button-outlined mr-2"
                            @click="generatePdf(header)"  target="_blank"/>
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                           
                            <FormField :labelName="$t('department')" fieldName="Department_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                    <CustomSelect 
                                        class="p-inputtext-sm" 
                                        v-model="header.Department_Code" 
                                        :url="this.$API_URL + 'list/lookup'" 
                                        :minLength="0" 
                                        :params="{ group : this.$LOOKUP_GROUP.DEPARTMENT}" 
                                        v-if="header" 
                                        :placeholder= "'Please Select'"
                                        :disabled="true" 
                                        :filter="true"
                                        @change="onChangeWorGroup()"
                                        />
                                        <small
                                        v-if="header && !header.Department_Code && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('department')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('Work_Group')" fieldName="Work_Group" v-model="header" labelClass="col-4" fieldClass="col-6">
                                    <CustomSelect 
                                        class="p-inputtext-sm" 
                                        v-model="header.Work_Group" 
                                        :url="this.$API_URL + 'list/lookup'" 
                                        :minLength="0" 
                                        :params="{ group : this.$LOOKUP_GROUP.WORK_GROUP}" 
                                        v-if="header" 
                                        :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.FULL_RELEASE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || header.Is_Additional) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                        :filter="true"
                                        @change="onChangeWorGroup(); getReleseMatrix()"
                                        />
                                        <small
                                        v-if="header && !header.Work_Group && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Work_Group')) }}
                                    </small>
                            </FormField>
                            <FormField :labelName="$t('WO_Type')" fieldName="WO_Type" v-model="header" labelClass="col-4" fieldClass="col-6"  v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <div class="flex flex-wrap gap-3">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.woType" name="WO_Type" :value="'Main'" v-if="header" @change="onClickIsAdditional()"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (this.header.Wo_Number) "/>
                                        <label for="WO_Type" class="ml-2 mr-2">Main</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.woType" name="WO_Type" :value="'Addendum'"  v-if="header" @change="onClickIsAdditional()"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (this.header.Wo_Number)"/>
                                        <label for="WO_Type" class="ml-2">Addendum</label>
                                    </div>
                                </div>

                                    <small v-if="header && !header.woType && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('WO_Type')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('Work_Order_Id')" fieldName="Work_Order_Id" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <CustomSelect name="Work_Order_Id" :filter="true"  v-if="header"
                                    v-model="header.Work_Order_Id" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/main_wo'"
                                    :minLength="0"
                                    :params="{is_wo : true, dept_code : this.header.Department_Code}" 
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || !(header.Is_Additional == true) || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || header.is_disabled_mainData " @change="handleWorkNumberChange"/>
                                    <small v-if="header && !header.Work_Order_Id && (header.Is_Additional == true) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('Work_Order_Id')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('MC_Number')" fieldName="MC_Number" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.Is_Additional">
                                <CustomSelect name="MC_Number" :filter="true"  v-if="header"
                                    v-model="header.MC_Number" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/listMCNo'"
                                    :minLength="0"
                                    :params="{no_wo : this.header.Work_Order_Id}" 
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || !(header.Is_Additional == true) || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || header.is_disabled_mainData" @change="getBoQ"/>
                                    <small v-if="header && (header.Is_Additional == true && header.Cut_Off_BoQ == true) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (((!header.MC_Number) && ((!header.AddScopes || header.AddScopes.length == 0) && (!header.DeducationScopes || header.DeducationScopes.length == 0))) || (header.MC_Number && ((!header.AddBoQ || header.AddBoQ.length == 0) && (!header.DeducationBoQ || header.DeducationBoQ.length == 0))))"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('MC_Number')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('location')" fieldName="Location_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Location_Code" :filter="true"  v-if="header"
                                    v-model="header.Location_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/location_code_wo'"
                                    :minLength="0"                              
                                    :params="{ docDate: (this.header.Created_Date != null ? this.header.Created_Date  : new Date()) }" 
                                    :disabled="mode == this.$FORM_MODE_VIEW || this.mode == this.$FORM_MODE_DELETE|| header.Is_Additional  || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || header.Status == this.$APPROVAL_STATUS.CLOSED || this.mode == this.$FORM_MODE_UPDATE_STATUS || header.is_disabled_mainData" 
                                    @change="onChangeLocation"/>                                   
                                    <small v-if="header && !header.Location_Code && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('location')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Company_Code" :filter="true"  v-if="header"
                                    v-model="header.Company_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/company_code_wo'"
                                    :minLength="0"                              
                                    :params="{ docDate: (this.header.Created_Date != null ? this.header.Created_Date  : new Date()), Location_Code: header.Location_Code }" 
                                    :disabled="mode == this.$FORM_MODE_VIEW || this.mode == this.$FORM_MODE_DELETE|| header.Is_Additional  || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || header.Status == this.$APPROVAL_STATUS.CLOSED || this.mode == this.$FORM_MODE_UPDATE_STATUS || header.is_disabled_mainData || (mode == this.$FORM_MODE_CREATE && !header.Location_Code)" 
                                    @change="handleCompanyChange"/>                                   
                                    <small v-if="header && !header.Company_Code && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('area')" fieldName="Company_Area_Id" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Company_Area_Id" :filter="true"  v-if="header"
                                    v-model="header.Company_Area_Id" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/wo_area_id'"
                                    :minLength="0"
                                    :params="{companyCode: this.header.Company_Code }" 
                                    :disabled="mode == this.$FORM_MODE_VIEW || this.mode == this.$FORM_MODE_DELETE|| header.Is_Additional || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || header.Status == this.$APPROVAL_STATUS.CLOSED || header.Status == this.$APPROVAL_STATUS.CLOSED || this.mode == this.$FORM_MODE_UPDATE_STATUS || (mode == this.$FORM_MODE_CREATE && !header.Location_Code)"/>
                                    <small v-if="header && !header.Company_Area_Id && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('area')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('Is_Tendering_Completed')" fieldName="Is_Tendering_Completed" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <Checkbox name="Is_Tendering_Completed" v-model="header.Is_Tendering_Completed" :binary="true" v-if="header"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL"
                                        @change="onClickIsTendering()"/>
                                    <Skeleton v-else-if="!header" />
                            </FormField>

                            <div class="field grid" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <label for="Period From" class="col-4">{{$t('no_spr')}}</label>
                                <div class="col-3 md-3">
                                    <InputText name="No_SPR" v-model="header.No_SPR" required="true" type="text" 
                                    :placeholder="$t('no_spr')" v-if="header" @keypress="onlyNumber"
                                     :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (this.header.Is_Tendering_Completed && this.header.Active_SAP) || !this.header.Is_Tendering_Completed || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL"
                                    maxlength="10"/>
                                    <small v-if="header &&((!header.No_SPR && (header.Is_Tendering_Completed)) ||  (header.is_notedit && !header.No_SPR)) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spr')) }}
                                    </small>
                                    <Skeleton v-else-if="!header" />
                                </div>

                                <label for="Item_SPR" class="col-1">/</label>
                                    <div class="col-2 md-2">
                                        <InputText name="Item" v-model="header.Item_SPR" required="true" type="text"
                                        :placeholder="$t('Item_SPR')" v-if="header"  @keypress="onlyNumber"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (this.header.Is_Tendering_Completed && this.header.Active_SAP) || !this.header.Is_Tendering_Completed || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL"
                                         maxlength="2"/>
                                    <small v-if="header &&((!header.Item_SPR && (header.Is_Tendering_Completed)) ||  (header.is_notedit && !header.Item_SPR)) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Item_SPR')) }}
                                    </small>
                                        <Skeleton v-else-if="!header" />
                                </div>
                            </div>

                          
                            <div class="field grid" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <label for="Period From" class="col-4">{{$t('no_spo')}}</label>
                                <div class="col-3 md-3">
                                    <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"  @keypress="onlyNumber"
                                    :disabled="header && !header.Is_Tendering_Completed || (mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL" 
                                    maxlength="10" @change="onChangeSPO"/>
                                     <small v-if="header && ((!header.No_SPO) && (header.Is_Tendering_Completed)) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                    </small>
                                    <Skeleton v-else-if="!header" />
                                </div>

                                <label for="Item" class="col-1">/</label>
                                    <div class="col-2 md-2">
                                        <InputText name="Item" v-model="header.Item" required="true" type="text"
                                        :placeholder="$t('Item_SPO')" v-if="header"  @keypress="onlyNumber"
                                        :disabled="header && !header.Is_Tendering_Completed || (mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL" 
                                        maxlength="2" @change="onChangeSPO"/>
                                    <small v-if="header && ((!header.Item) && (header.Is_Tendering_Completed)) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Item_SPO')) }}
                                    </small>
                                        <Skeleton v-else-if="!header" />
                                </div>
                            </div>

                            <FormField :labelName="$t('tgl_spo')" fieldName="SPO_Date" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <DatePicker name="SPO_Date" v-model="header.SPO_Date" type="text"
                                :placeholder="$t('tgl_spo')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (this.header.Is_Tendering_Completed && this.header.Active_SAP) || !this.header.Is_Tendering_Completed || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL"/>
                                <small
                                    v-if="header && ((!header.SPO_Date) && (header.Is_Tendering_Completed)) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('tgl_spo')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('no_spk')" fieldName="No_SPK" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <InputText name="No_SPK" v-model="header.No_SPK" required="true" type="text"
                                    :placeholder="$t('no_spk')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (this.header.Is_Tendering_Completed && this.header.Active_SAP) || !this.header.Is_Tendering_Completed || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL" />              
                            </FormField>
                               <FormField labelClass="col-4" fieldClass="col-6" v-if="header && (header.Is_Tendering_Completed && this.header.Active_SAP)">
                                   <Button icon="pi pi-download" label="Adopt SAP" style="width: 120px;" class="p-button mr-2" @click="confirmAdoptSAP()" :disabled="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE || header.Deleted_Date" />
                               </FormField>
                           
                            <FormField :labelName="$t('Work_Description')" fieldName="Work_Description" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea name="Work_Description" v-model="header.Work_Description" required="true" type="text"
                                    :placeholder="$t('Work_Description')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || (this.header.Is_Tendering_Completed && this.header.Active_SAP)"
                                    :maxlength="this.validateInput ? 40 : null"
                                    autoResize />
                                    <small v-if="header && !header.Work_Description && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Work_Description')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('Planned_Start_Date')" fieldName="Planned_Start_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="Planned_Start_Date" v-model="header.Planned_Start_Date" type="text"
                                :placeholder="$t('Planned_Start_Date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL"/>
                                <small
                                    v-if="header && !header.Planned_Start_Date && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('Planned_Start_Date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('Duration')" fieldName="Duration" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber  name="Duration" v-model="header.Duration"
                                :placeholder="$t('Duration')" v-if="header" :useGrouping="false" :min="0"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || (this.header.Is_Tendering_Completed && this.header.Active_SAP)" />

                                <small
                                    v-if="header && !header.Duration && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('Duration')) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('WBS_Allocation')" fieldName="WBS_Allocation" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.Work_Group != this.$WorkGroup.Project_Admin_Creator_AR">
                                <InputText name="WBS_Allocation" v-model="header.WBS_Allocation" required="true" type="text"
                                    :placeholder="$t('WBS_Allocation')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || (this.header.Is_Tendering_Completed && this.header.Active_SAP && !this.canInput)" />
                                    <small v-if="header && (!header.WBS_Allocation && (this.header.Department_Code == this.$DEPARTMENT.PROJECT) && (this.header.Work_Group == this.$WorkGroup.Project_Engineering || this.header.Work_Group == this.$WorkGroup.Project_Execution)) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('WBS_Allocation')) }}
                                     </small>
                            </FormField>
                            <FormField :labelName="$t('contractor')" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)" 
                            fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Created_Date != null ? this.header.Created_Date  : null)}" 
                                 
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || (this.header.Is_Tendering_Completed && this.header.Active_SAP) || header.Is_Additional || header.is_disabled_mainData" />
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && this.header.Is_Tendering_Completed"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('contractor')) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('contract_value')" fieldName="Contract_Value" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                <InputNumber name="Contract_Value" v-model="header.Contract_Value" required="true" :useGrouping="true" :maxFractionDigits="3" :minFractionDigits="0"
                                    :placeholder="$t('contract_value')" v-if="header"
                                    :disabled="!this.header.Is_Tendering_Completed   ||mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (this.header.Is_Tendering_Completed && this.header.Active_SAP) || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL" />
                                    <small v-if="header && (!header.Contract_Value && header.Is_Tendering_Completed) && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('contract_value')) }}
                                    </small>
                            </FormField>
                            <FormField :labelName="$t('Currency')" fieldName="Currency" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (category == this.$CategoryWo.Execution || category == this.$CategoryWo.Engineering)">
                                    <CustomSelect  v-if="header" name="Currency" 
                                            v-model="header.Currency"  
                                            :url="$API_URL + 'list/lookup'"
                                            :params="{ group: $LOOKUP_GROUP.CURRENCY }" 
                                            :minLength="0" 
                                            :filter="true"
                                            :placeholder="$t('Currency')"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || (this.header.Is_Tendering_Completed && this.header.Active_SAP) " />
                                    <small v-if="header && !header.Currency && submitted && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && this.header.Is_Tendering_Completed"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Currency')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('Attachment')" :fileModels="header.files_data" v-if="header" labelClass="col-4" fieldClass="col-6">
                                <CustomFileUpload
                                    :fileModels="viewFiles"
                                    :multiple="true" 
                                    :showUploadButton="false" 
                                    :showCancelButton="false" 
                                    :customUpload="false" 
                                    @select="onFileSelect" 
                                    @remove="onFileRemove" 
                                    :viewOnly="true" 
                                    :showHeader="false"
                                    :showremove="true"
                                    :disabledRemove="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL"
                                    @removefile="removeFile"
                                    @download="onDownloadFile"
                                    />                                   
                            </FormField>
                        
                            <FormField :labelName="''" :fileModels="header.files_data" v-model="header" v-if="header" fieldClass="col-6" labelClass="col-4">
                                <CustomFileUpload 
                                :fileModels="header.files_data"
                                :maxFileSize="5242880"
                                :multiple="true" 
                                :showUploadButton="false"
                                :showCancelButton="false" 
                                :customUpload="false" 
                                accept="image/*,.xlsx,.xls,.pdf,.zip,.doc,.docx"
                                @select="onFileSelect($event, header)"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL"
                                @remove="onFileRemove($event, header)" />
                            </FormField>

                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('no_wo')" fieldName="Wo_Number" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="no_wo" v-model="header.Wo_Number" required="true" type="text"
                                    :placeholder="$t('no_wo')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                              <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header && !this.$store.getters.getIsUpdateWo"
                                    :disabled="true" />
                                  
                                    <CustomSelect 
                                        class="p-inputtext-sm" 
                                        v-model="header.Status" 
                                        :url="this.$API_URL + 'list/lookup'" 
                                        :minLength="0" 
                                        :params="{ group : $LOOKUP_GROUP.TRANSACTION_STATUS }" 
                                        v-else
                                        :disabled="mode != this.$FORM_MODE_UPDATE_STATUS"
                                        :filter="true"
                                        />
                                        <small
                                        v-if="header && !header.Status && submitted && header.Status != this.$APPROVAL_STATUS.CLOSED && mode == this.$FORM_MODE_UPDATE_STATUS"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Status')) }}
                                    </small>
                                    
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.FULL_RELEASE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_REVISION || isUpdateWoCLosed)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT && mode != this.$FORM_MODE_DELETE || (header.Status != this.$APPROVAL_STATUS.FULL_RELEASE && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION)) && !isUpdateWoCLosed"/>
                                    <small v-if="header &&((!header.Reason && ((header.Status == this.$APPROVAL_STATUS.FULL_RELEASE || mode == this.$FORM_MODE_DELETE) || isUpdateWoCLosed ) )) && submitted && mode != this.$FORM_MODE_VIEW"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                            <Card style="border:3px solid #dcddde;">
                                <template #title><span style="font-size: 15px;">PIC Approver</span></template>
                                <template #content>
                                    <FormField :labelName="$t('Usrnm_Head_User')" fieldName="Usrnm_Head_User" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_Head_User" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_Head_User" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.HEAD_USER, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled=" !is_head_user || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                            <small v-if="header && !header.Usrnm_Head_User && is_head_user && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_Head_User')) }}
                                        </small>
                                    </FormField>
                                        
                                    <FormField :labelName="$t('Usrnm_Lead_Engineering')" fieldName="Usrnm_Lead_Engineering" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_Lead_Engineering" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_Lead_Engineering" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.LEAD_ENGINEERING, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled="!is_lead_engineering || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header && !header.Usrnm_Lead_Engineering && is_lead_engineering && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_Lead_Engineering')) }}
                                        </small>
                                    </FormField>

                                    <FormField :labelName="$t('Usrnm_Head_Project_Dept')" fieldName="Usrnm_Head_Project_Dept" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_Head_Project_Dept" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_Head_Project_Dept" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.HEAD_PROJECT_DEPARTMENT, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled="!is_head_dept || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header && !header.Usrnm_Head_Project_Dept && is_head_dept && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_Head_Project_Dept')) }}
                                        </small>
                                    </FormField>
                                        
                                    <FormField :labelName="$t('Usrnm_PM_Closing')" fieldName="Usrnm_PM_Closing" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_PM_Closing" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_PM_Closing" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.PROJECT_MANAGER, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled="!is_pm_closing || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header && !header.Usrnm_PM_Closing && is_pm_closing && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_PM_Closing')) }}
                                        </small>
                                    </FormField>

                                            
                                    <FormField :labelName="$t('Usrnm_Lead_Engineering_Closing')" fieldName="Usrnm_Lead_Engineering_Closing" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_Lead_Engineering_Closing" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_Lead_Engineering_Closing" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.LEAD_ENGINEERING, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled="!is_lead_engineering_closing || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header && !header.Usrnm_Lead_Engineering_Closing && is_lead_engineering_closing && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_Lead_Engineering_Closing')) }}
                                        </small>
                                    </FormField>

                                    <FormField :labelName="$t('Usrnm_Head_User_Closing')" fieldName="Usrnm_Head_User_Closing" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_Head_User_Closing" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_Head_User_Closing" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.HEAD_USER, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled="!is_head_user_closing || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header && !header.Usrnm_Head_User_Closing && is_head_user_closing && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_Head_User_Closing')) }}
                                        </small>
                                    </FormField>
                                        
                                    <FormField :labelName="$t('Usrnm_Head_Project_Dept_Closing')" fieldName="Usrnm_Head_Project_Dept_Closing" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_Head_Project_Dept_Closing" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_Head_Project_Dept_Closing" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.HEAD_PROJECT_DEPARTMENT, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled="!is_head_dept_closing || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header && !header.Usrnm_Head_Project_Dept_Closing && is_head_dept_closing && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_Head_Project_Dept_Closing')) }}
                                        </small>
                                    </FormField>

                                    <FormField :labelName="$t('Usrnm_PIC_AR_Closing')" fieldName="Usrnm_PIC_AR_Closing" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Usrnm_PIC_AR_Closing" :filter="true"  v-if="header"
                                            v-model="header.Usrnm_PIC_AR_Closing" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/usernameWilmar'"
                                            :minLength="0"
                                            :params="{ job_postion:this.$UserLevel.PIC_CREATOR_AR, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                            :disabled="!is_pic_creator_ar || mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header && !header.Usrnm_PIC_AR_Closing && is_pic_creator_ar && (submitted1 || submitted) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Usrnm_PIC_AR_Closing')) }}
                                        </small>
                                    </FormField>

							        <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status != this.$APPROVAL_STATUS.DRAFT) && mode == this.$FORM_MODE_EDIT">
                                        <InputText name="Reason" v-model="header.ReasonPicAppr" required="true" type="text"
                                            :placeholder="$t('reason')" v-if="header"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header &&((!header.ReasonPicAppr)) && submitted1 && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                            </small>
                                    </FormField>

                                </template>
                                <template #footer>
                                    <div style="text-align: right">
                                        <Button icon="pi pi-upload" label="Update PIC" style="width: 120px;" class="p-button-success" @click="confirmPicAppr($event)" v-if="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && header && (header.Status != this.$APPROVAL_STATUS.DRAFT)" />
                                    </div>
                                </template>
                            </Card>
                        </div>
                        
                        <div class="grid gap-4 mt-3" v-if="header && header.Is_Additional && header.Cut_Off_BoQ">
                            <div class="col-12 px-3">
                                <div style="display:flex;align-items:center;gap:16px;">
                                    <label style="margin:0"><b>{{ $t('Initial_Instruction') }}</b></label>
                                    <Checkbox v-model="header.Is_show_Print_Scope" :binary="true"
                                        :disabled="mode == this.$FORM_MODE_DELETE" />
                                </div>
                            </div>
                            <div class="col-6 px-3" v-if="header && header.Is_Additional && header.Cut_Off_BoQ">
                                <DataTable v-if="header" :value="header.AddScopes ? header.AddScopes : null"
                                    class="p-datatable-sm editable-cells-table" showGridlines>
                                    <Column :exportable="false" style="width: 40px; min-width: 40px; max-width: 40px;">
                                        <template #header>
                                            <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                                @click="addDetail1()"
                                                :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS" />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                @click="deleteDetail1(slotProps)"
                                                :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </template>
                                    </Column>
                                    <Column field="Description" :header="$t('AddScope')" Key="Id">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                    :placeholder="$t('description')" @change="onCellEditComplete1(slotProps)"
                                                    :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small
                                                    v-if="header && !slotProps.data.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                                </small>
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>

                            <div class="col-6 px-3" v-if="header && header.Is_Additional && header.Cut_Off_BoQ">
                                <DataTable v-if="header" :value="header.DeducationScopes ? header.DeducationScopes : null"
                                    class="p-datatable-sm editable-cells-table" showGridlines>
                                    <Column :exportable="false" style="width: 40px; min-width: 40px; max-width: 40px;">
                                        <template #header>
                                            <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                                @click="addDetail2()"
                                                :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS" />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                @click="deleteDetail2(slotProps)"
                                                :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </template>
                                    </Column>
                                    <Column field="Description" :header="$t('DeducationScope')" Key="Id">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                    :placeholder="$t('description')" @change="onCellEditComplete2(slotProps)"
                                                    :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small
                                                    v-if="header && !slotProps.data.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                                </small>
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>

                        </div>

                        <div class="grid gap-4 mt-3" v-if="header && header.Is_Additional && header.Cut_Off_BoQ">
                            <div class="col-12 px-3">
                                <div style="display:flex;align-items:center;gap:16px;">
                                    <label style="margin:0"><b>{{ $t('Instruction_BaseMC') }}</b></label>
                                    <Checkbox v-model="header.Is_show_Print_ScopeMC" :binary="true"
                                        :disabled="mode == this.$FORM_MODE_DELETE" />
                                </div>
                            </div>
                            <div class="col-6 px-3" v-if="header && header.Is_Additional && header.Cut_Off_BoQ">
                                <h6 class="mb-2">Additional Scope</h6>
                                <div style="max-height: 400px; overflow: auto;">
                                    <DataTable v-if="header" :value="header.AddBoQ ? header.AddBoQ: null"
                                        class="p-datatable-sm editable-cells-table" showGridlines>
                                    <Column field="No_BoQ" :header="$t('No')" style="width: 100px; min-width: 100px; max-width: 100px;">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <InputText 
                                                    v-model="slotProps.data.No_BoQ"
                                                    :placeholder="$t('No')"

                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="Scope" :header="$t('Scope')">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data.Scope"
                                                    :placeholder="$t('Scope')"
                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="Unit" :header="$t('Unit')">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <InputText 
                                                    v-model="slotProps.data.Unit"
                                                    :placeholder="$t('Unit')"
                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="Volume" :header="$t('Volume')" style="width: 100px; min-width: 100px; max-width: 100px;">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <InputNumber 
                                                    v-model="slotProps.data.Volume"
                                                    :placeholder="$t('Volume')"
                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                    :maxFractionDigits="6"
                                                    :minFractionDigits="0"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                                </div>
                            </div>
                            <div class="col-6 px-3" v-if="header && header.Is_Additional && header.Cut_Off_BoQ">
                                <h6 class="mb-2">Deduction Scope</h6>
                                <div style="max-height: 400px; overflow: auto;">
                                    <DataTable v-if="header" :value="header.DeducationBoQ ? header.DeducationBoQ: null"
                                        class="p-datatable-sm editable-cells-table" showGridlines>
                                    <Column field="No_BoQ" :header="$t('No')" style="width: 100px; min-width: 100px; max-width: 100px;">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <InputText 
                                                    v-model="slotProps.data.No_BoQ"
                                                    :placeholder="$t('No')"
                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="Scope" :header="$t('Scope')" style="width: 300px; min-width: 300px; max-width: 300px;">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data.Scope"
                                                    :placeholder="$t('Scope')"
                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="Unit" :header="$t('Unit')" style="width: 80px; min-width: 80px; max-width: 80px;">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <InputText 
                                                    v-model="slotProps.data.Unit"
                                                    :placeholder="$t('Unit')"
                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="Volume" :header="$t('Volume')" style="width: 100px; min-width: 100px; max-width: 100px;">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <InputNumber 
                                                    v-model="slotProps.data.Volume"
                                                    :placeholder="$t('Volume')"
                                                    :disabled="true"
                                                    v-show="slotProps.data.mode != 'Delete'"
                                                    :maxFractionDigits="6"
                                                    :minFractionDigits="0"
                                                    v-lock-input="true"
                                                />
                                                <br/>
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                                </div>
                            </div>
                        </div>



                        <div class="col-6" v-if="header && header.Is_Additional && !header.Cut_Off_BoQ">
                            <DataTable v-if="header" :value="header.AddScopes ? header.AddScopes : null"
                                class="p-datatable-sm editable-cells-table" showGridlines>
                                <Column :exportable="false" style="width: 40px; min-width: 40px; max-width: 40px;">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail1()"
                                            :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail1(slotProps)"
                                            :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Description" :header="$t('AddScope')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <Textarea 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('description')" @change="onCellEditComplete1(slotProps)"
                                                :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                            <br/>
                                            <small
                                                v-if="header && !slotProps.data.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>

                        <div class="col-6" v-if="header && header.Is_Additional && !header.Cut_Off_BoQ">
                            <DataTable v-if="header" :value="header.DeducationScopes ? header.DeducationScopes : null"
                                class="p-datatable-sm editable-cells-table" showGridlines>
                                <Column :exportable="false" style="width: 40px; min-width: 40px; max-width: 40px;">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail2()"
                                            :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail2(slotProps)"
                                            :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Description" :header="$t('DeducationScope')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <Textarea 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('description')" @change="onCellEditComplete2(slotProps)"
                                                :disabled="(mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.mode == this.$FORM_MODE_UPDATE_STATUS"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                            <br/>
                                            <small
                                                v-if="header && !slotProps.data.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>

                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header"  :tableName="'WorkOrderCreation'" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import IndexBase from '../Helper/IndexBase.vue';
import moment from 'moment';
import { Text } from 'vue';
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "WoReleaseIndex",
            url: this.$API_URL + "WoRelease/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Table_Name", header: "Table Name" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            participant : null,
            inspection : null,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog3,
            is_disabled_add : true,
            AddScope : null,
            DeducationScope: null,
            listPicAppr1 : [],
            listPicAppr2 : [],
            ReasonPicAppr : "",
            submitted1 : false,
            isLoading: false,
            canInput: false,
            validateInput:false,
            onlyDraft: false,
        }
    },
    methods: {
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },  
        title(mode){
            let title = mode;
            title = title == "UpdateStatus" ? "Update Status" : title;
            return title;
        },
        confirmUpdateWo(event) {
            this.submitted = true;
            var self = this;
            this.header.is_submit = false;
            if((!this.header.Status || !this.header.Reason))
                return false;
           
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure to update status ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                        this.updateWo();
                },
                reject: () => {

                }
            });
            
        },
        updateWo() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.url +"updatewo", this.header)
                .then((response) => {
                    if (response.data.success) {
                        self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Work Order Status has been update successfully", life: 3000 } });                        
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        removeFile(event){
           var file = {...event};
            let self = this;
            this.$emit('block-ui');
            this.$axios.post(this.url+"removefile", file)
            .then((response) => {
                if (response.data.success) {
                    
                    let attachment = response.data.data.attachment;
                    
                    self.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 3000 });
                    this.$emit('unblock-ui');
                    
                    if(attachment == '' || attachment == null){
                        self.viewFiles = [];
                    }
                    else
                    {
                        var listAttachment = attachment.split(';');
                        self.viewFiles = [];
                        listAttachment.forEach(a => {
                            if (a != '') {
                                var name = a.split("/").at(-1);
                                var d = {
                                    name: name,
                                    path: a,
                                    id: self.header.Id
                                };

                                self.viewFiles.push(d);
                            }
                        });
                    }
                }
                else {
                    self.showError('Error Saving Data', response.data.message);
                }
            })
            .catch(function (error) {
                self.showError('Error Saving Data', error);
            });
        },
        confirmPicAppr(event) {
            this.submitted1 = true;

            if(this.mode != this.$FORM_MODE_DELETE){

                if(this.validationFromPic())
                {
                    return;
                }
                if (!this.header.ReasonPicAppr) {
                    return;
                }
            }
            this.ReasonPicAppr = this.header.ReasonPicAppr;
            
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveDataPicAppr();
                },
                reject: () => {

                }
            });
            
        },
        saveDataPicAppr() {
            this.$emit('block-ui');
            var self = this;
              
             this.$axios.post(this.url + "saveAppr", this.header)
                .then((response) => {
                    if (response.data.success) {
                        self.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
                        
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                    self.getData();
                    self.$emit('unblock-ui');
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        confirmUpdateDetail(event) {
            // no validation, set special mode and save
            this.submitted = true;
            if(!this.header) return;
            this.header.mode = this.$FORM_MODE_VIEW_SAVE;
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure to update tick print?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
        },
        confirmAdoptSAP(){
            if(this.validationFromAdoptSAP()){
                return;
            }          
            this.adoptSAP();
        },
        adoptSAP(){
            this.$emit('block-ui');
            var self = this;
              
             this.$axios.post(this.url + "adoptSAP", this.header)
                .then((response) => {
                    if (response.data.success) {
                        var dataAdopt = response.data.data;
                        self.header.SPO_Date= dataAdopt.SPO_Date;
                        self.header.Contractor_Code= dataAdopt.Contractor_Code;
                        self.header.Contract_Value= dataAdopt.Contract_Value;
                        self.header.Currency= dataAdopt.Currency;
                        self.header.WBS_Allocation= dataAdopt.WBS_Allocation;
                        self.canInput = dataAdopt.WBS_Allocation == null || dataAdopt.WBS_Allocation == "" ? true : false;
                        self.header.No_SPK = dataAdopt.No_SPK;
                        self.header.No_SPO = dataAdopt.No_SPO;
                        self.header.Item = dataAdopt.Item;
                        self.header.Item_SPR = dataAdopt.Item_SPR;
                        self.header.No_SPR = dataAdopt.No_SPR;
                        self.header.Duration = dataAdopt.Duration;
                        self.header.Work_Description = dataAdopt.Work_Description;
                        self.header.Adopt_SAP = dataAdopt.Adopt_SAP;
                        self.header.Flag_Adopt_SAP = dataAdopt.Flag_Adopt_SAP;
                        self.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
                        
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                    self.$emit('unblock-ui');
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        handleCompanyChange(e) {
            this.getReleseMatrix();
            this.$nextTick(() => {
                 this.onChangeCompany(e);
            });
        },
        handleContractorChange() {
           
            this.getReleseMatrix();
            this.$nextTick(() => {
                 this.onChangeContractor();
            });
        },
        handleWorkNumberChange(e){
            this.onChangeWorkNumber(e)
            this.$nextTick(() => {
                 this.getReleseMatrix();
            });
        },
        getReleseMatrix() {

            var self = this;
            if(!this.header.Company_Code || !this.header.Work_Group || !this.header.Department_Code){
                self.listPicAppr1 = [];
                self.listPicAppr2 = [];
                return false;
            }

            this.$emit('block-ui');
            
             this.$axios.post(this.url + "getReleseMatrix", this.header)
                .then((response) => {
                    if (response.data.success) {
                        this.$emit('unblock-ui');
                        
                        self.listPicAppr1 = response.data.data.listPicAppr1;
                        self.listPicAppr2 = response.data.data.listPicAppr2;
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        onClickIsTendering()
        {               
            if(!this.header.Is_Tendering_Completed){
                this.header.No_SPR = null;
                this.header.SPO_Date = null;
                this.header.No_SPO = null;
                this.header.Item = null;
                this.header.Item_SPR = null;
            }
        },
        generatePdf(model){
            this.$emit('block-ui');
            var self = this;
            model.valueLink = this.$store.getters.getUrlApp + this.$route.fullPath;
            model.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())}) ${ model !=null && model.Rev != 0 ? '- Document Rev ' + model.Rev : ""}`;
            
            this.$axios.post(this.$API_URL + "WoRelease/" + "downloadprint", model,{
            responseType: 'blob',
            timeout: this.$AXIOS_TIMEOUT_LONG
            })
            .then((response) => {
                //let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            })
            .catch(function (err) {
                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                self.blocked = false;
            })
            .finally(() => {
                self.$emit('unblock-ui');
            });
        },  
        getData() {
            if (this.isLoading) return;
            this.isLoading = true;
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    
                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }
                 
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detailLog = self.header.DetailLog;
                    self.AddScope = response.data.data.AddScope;
                    self.DeducationScope = response.data.data.DeducationScope;
                    self.listPicAppr1 = response.data.data.listPicAppr1;
                    self.listPicAppr2 = response.data.data.listPicAppr2;     
                    if(self.header.Department_Code == this.$DEPARTMENT.PROJECT && (self.header.Work_Group == this.$WorkGroup.Project_Engineering || self.header.Work_Group == this.$WorkGroup.Project_Execution))
                    {
                        self.validateInput = true;
                    }      
                    //anggap Is_Additional itu tye wo karna ini field dari awal dibuat jika diubah lagi harus ubah type data dan semua data juga harus di update 
                    //jika false = Main dan True = Addendum
                    if(this.header.Is_Additional){
                        this.header.woType = "Addendum";
                    }else{
                        this.header.woType = "Main";
                    }

                    
                    if(self.mode == this.$FORM_MODE_CREATE){
                        self.header.Department_Code = this.$store.getters.getDepartmentWo;
                        // default to show initial instruction checkbox when creating
                        if (self.header.Is_show_Print_Scope == null) self.header.Is_show_Print_Scope = true;
                        if (self.header.Is_show_Print_ScopeMC == null) self.header.Is_show_Print_ScopeMC = true;
                    }
                            
                    if(self.mode != this.$FORM_MODE_CREATE){
                        this.header.ReasonPicAppr = this.ReasonPicAppr;
                    }
                    
                    if(self.header.Attachment){
                            var attachment = this.header.Attachment.split(';');
                            self.viewFiles = [];
                            attachment.forEach(a => {
                                if (a != '') {
                                    var name = a.split("/").at(-1);
                                    var d = {
                                        name: name,
                                        path: a,
                                        id: self.header.Id
                                    };

                                    self.viewFiles.push(d);
                                }
                            });
                        }
                 
                })
                .catch(function (error) {
                    self.showError("Error", error);
                }
                ).finally(() => {
                    this.isLoading = false;
                });
           
        },
        getBoQ() {
            var self = this;
          
            const encodedMC = encodeURIComponent(this.header.MC_Number);
            
            this.$axios.get( this.$API_URL + "WoRelease/GetBoQ/"+ encodedMC) 
                .then((response) => {                   
                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }
                    if (this.mode == this.$FORM_MODE_CREATE) 
                    {
                        self.header.AddBoQ = [];
                        self.header.DeducationBoQ = [];
                        
                    } else{
                        if (Array.isArray(self.header.AddBoQ) && self.header.AddBoQ.length > 0) {
                            self.header.AddBoQ.forEach(item => {
                                item.mode = this.$FORM_MODE_DELETE;
                            });
                        }

                        if (Array.isArray(self.header.DeducationBoQ) && self.header.DeducationBoQ.length > 0) {
                            self.header.DeducationBoQ.forEach(item => {
                                item.mode = this.$FORM_MODE_DELETE;
                            });
                        }
                    }

                    self.header.AddBoQ = response.data.data.header.AddBoQ;
                    self.header.DeducationBoQ = response.data.data.header.DeducationBoQ;
                    self.header.SPO_Category_Type = response.data.data.header.SPO_Category_Type;
                 
                })
                .catch(function (error) {
                    self.showError("Error", error);
                }
                ).finally(() => {
                    this.isLoading = false;
                });
           
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            var data = new FormData();

            data.append("Id", this.header.Id);
            if(this.header.Wo_Number != null) data.append("Wo_Number", this.header.Wo_Number); 
            if(this.header.Status != null) data.append("Status", this.header.Status);
            if(this.header.Reason != null)  data.append("Reason", this.header.Reason);
            if(this.header.Company_Code != null) data.append("Company_Code", this.header.Company_Code);
            if(this.header.Company_Area_Id != null) data.append("Company_Area_Id", this.header.Company_Area_Id);
            if(this.header.Department_Code != null) data.append("Department_Code", this.header.Department_Code);
            if(this.header.Contractor_Code != null) data.append("Contractor_Code", this.header.Contractor_Code);
            if(this.header.Currency != null) data.append("Currency", this.header.Currency);
            if(this.header.Contract_Value != null) data.append("Contract_Value", this.header.Contract_Value);
            if(this.header.WBS_Allocation != null) data.append("WBS_Allocation", this.header.WBS_Allocation);

            if(this.header.Work_Group) data.append("Work_Group", this.header.Work_Group);
        
            if(this.header.No_SPR != null) data.append("No_SPR", this.header.No_SPR);
            if(this.header.No_SPO !=null) data.append("No_SPO", this.header.No_SPO);
            if(this.header.No_SPK !=null) data.append("No_SPK", this.header.No_SPK);

            if(this.header.Work_Description) data.append("Work_Description", this.header.Work_Description);
            if(this.header.Duration) data.append("Duration", this.header.Duration);
            if(this.Adopt_SAP) data.append("Adopt_SAP", this.Adopt_SAP);
            
            if(this.header.Target_Date) data.append("Target_Date1",moment(this.header.Target_Date).format('YYYY/MM/DD').toString());
            if(this.header.SPO_Date) data.append("SPO_Date1",moment(this.header.SPO_Date).format('YYYY/MM/DD').toString());
            if(this.header.Planned_Start_Date) data.append("Planned_Start_Date1",moment(this.header.Planned_Start_Date).format('YYYY/MM/DD').toString());
            //data.append("Target_Reschedule1",moment(this.header.Target_Reschedule).format('YYYY/MM/DD').toString());
            //data.append("Start_Work1",moment(this.header.Start_Work).format('YYYY/MM/DD').toString());
            //data.append("Finish_Work1",moment(this.header.Finish_Work).format('YYYY/MM/DD').toString());

            if(this.header.Usrnm_Head_User != null) data.append("Usrnm_Head_User", this.header.Usrnm_Head_User);
            if(this.header.Usrnm_Lead_Engineering !=null) data.append("Usrnm_Lead_Engineering", this.header.Usrnm_Lead_Engineering);
            if(this.header.Usrnm_Head_Project_Dept !=null) data.append("Usrnm_Head_Project_Dept", this.header.Usrnm_Head_Project_Dept);
            if(this.header.Usrnm_PIC_Engineering_Closing !=null) data.append("Usrnm_PIC_Engineering_Closing", this.header.Usrnm_PIC_Engineering_Closing);
            if(this.header.Usrnm_Head_Project_Dept_Closing !=null) data.append("Usrnm_Head_Project_Dept_Closing", this.header.Usrnm_Head_Project_Dept_Closing);
            if(this.header.Usrnm_PM_Closing != null) data.append("Usrnm_PM_Closing", this.header.Usrnm_PM_Closing);
            if(this.header.Usrnm_Head_User_Closing != null) data.append("Usrnm_Head_User_Closing", this.header.Usrnm_Head_User_Closing);
            if(this.header.Usrnm_PIC_AR_Closing != null) data.append("Usrnm_PIC_AR_Closing", this.header.Usrnm_PIC_AR_Closing);
            if(this.header.Usrnm_Lead_Engineering_Closing != null)  data.append("Usrnm_Lead_Engineering_Closing", this.header.Usrnm_Lead_Engineering_Closing);

            if(this.header.Item != null) data.append("Item", this.header.Item);
            if(this.header.Item_SPR != null) data.append("Item_SPR", this.header.Item_SPR);

            if(this.header.Work_Order_Id != null) data.append("Work_Order_Id", this.header.Work_Order_Id);
            if(this.header.Is_Additional != null) data.append("Is_Additional", this.header.Is_Additional);
            if(this.header.MC_Number != null) data.append("MC_Number", this.header.MC_Number);
            
            if(this.header.Is_Tendering_Completed == null) this.header.Is_Tendering_Completed = false;
            if(this.header.Is_Tendering_Completed) data.append("Is_Tendering_Completed", this.header.Is_Tendering_Completed);

            if(this.header.Is_Old_Data) data.append("Is_Old_Data", this.header.Is_Old_Data);
            if(this.header.Adopt_SAP) data.append("Adopt_SAP", this.header.Adopt_SAP);
            if(this.header.Active_SAP) data.append("Active_SAP", this.header.Active_SAP);
            if(this.header.Flag_Adopt_SAP) data.append("Flag_Adopt_SAP", this.header.Flag_Adopt_SAP);
            if(this.header.SPO_Category_Type) data.append("SPO_Category_Type", this.header.SPO_Category_Type);
            if(this.header.Cut_Off_BoQ) data.append("Cut_Off_BoQ", this.header.Cut_Off_BoQ);
            if(this.header.Location_Code) data.append("Location_Code", this.header.Location_Code);
            if(this.header.Is_show_Print_ScopeMC) data.append("Is_show_Print_ScopeMC", this.header.Is_show_Print_ScopeMC);
            if(this.header.Is_show_Print_Scope) data.append("Is_show_Print_Scope", this.header.Is_show_Print_Scope);
            data.append("mode", this.header.mode);

            if(this.category) data.append("Category", this.category);
            

            if(this.header.Wo_Number_Main) data.append("Wo_Number_Main", this.header.Wo_Number_Main);
            
            
            //attach file
            if(this.header.files_data != null)
                for(var x=0; x < this.header.files_data.length;x++){
                    var file = this.header.files_data[x];
                    data.append("attachments.File", file, file.name);
            }

            for(var i=0; i< this.header.AddScopes.length;i++){
                var AddScopes = this.header.AddScopes[i];
                if(AddScopes.mode != null)
                    data.append("AddScopes[" + i + "].mode", AddScopes.mode);
                if(AddScopes.Id != null)
                    data.append("AddScopes[" + i + "].Id", AddScopes.Id);
                if(AddScopes.Description != null)
                    data.append("AddScopes[" + i + "].Description", AddScopes.Description);
                    
            }

            for(var j=0; j< this.header.DeducationScopes.length;j++){
                var DeducationScopes = this.header.DeducationScopes[j];
                if(DeducationScopes.mode != null)
                    data.append("DeducationScopes[" + j + "].mode", DeducationScopes.mode);
                if(DeducationScopes.Id != null)
                    data.append("DeducationScopes[" + j + "].Id", DeducationScopes.Id);
                if(DeducationScopes.Description != null)
                    data.append("DeducationScopes[" + j + "].Description", DeducationScopes.Description);
                    
            }

            if (this.header.AddBoQ != null) {
                for (var i = 0; i < this.header.AddBoQ.length; i++) {
                    var item = this.header.AddBoQ[i];

                    if (item.mode != null)
                        data.append(`AddBoQ[${i}].mode`, item.mode);

                    if (item.Id != null)
                        data.append(`AddBoQ[${i}].Id`, item.Id);

                    if (item.Work_Order_Id != null)
                        data.append(`AddBoQ[${i}].Work_Order_Id`, item.Work_Order_Id);

                    if (item.Type != null)
                        data.append(`AddBoQ[${i}].Type`, item.Type);

                    if (item.No_BoQ != null)
                        data.append(`AddBoQ[${i}].No_BoQ`, item.No_BoQ);

                    if (item.Scope != null)
                        data.append(`AddBoQ[${i}].Scope`, item.Scope);

                    if (item.Unit != null)
                        data.append(`AddBoQ[${i}].Unit`, item.Unit);

                    if (item.Volume != null)
                        data.append(`AddBoQ[${i}].Volume`, item.Volume);
                }
            }

            if (this.header.DeducationBoQ != null) {
                for (var i = 0; i < this.header.DeducationBoQ.length; i++) {
                    var item = this.header.DeducationBoQ[i];

                    if (item.mode != null)
                        data.append(`DeducationBoQ[${i}].mode`, item.mode);

                    if (item.Id != null)
                        data.append(`DeducationBoQ[${i}].Id`, item.Id);

                    if (item.Work_Order_Id != null)
                        data.append(`DeducationBoQ[${i}].Work_Order_Id`, item.Work_Order_Id);

                    if (item.Type != null)
                        data.append(`DeducationBoQ[${i}].Type`, item.Type);

                    if (item.No_BoQ != null)
                        data.append(`DeducationBoQ[${i}].No_BoQ`, item.No_BoQ);

                    if (item.Scope != null)
                        data.append(`DeducationBoQ[${i}].Scope`, item.Scope);

                    if (item.Unit != null)
                        data.append(`DeducationBoQ[${i}].Unit`, item.Unit);

                    if (item.Volume != null)
                        data.append(`DeducationBoQ[${i}].Volume`, item.Volume);
                }
            }

            this.$axios.post(this.url, data, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Wo Release has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Wo Release has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;
            
            if(this.mode != this.$FORM_MODE_DELETE){

                if(this.validationFromField())
                return false;
           

                // existing rule for Addendum without Cut Off BoQ: both AddScopes and DeducationScopes must exist
                if (this.header.Is_Additional == true && !this.header.Cut_Off_BoQ) {
                    if (!this.header.AddScopes || !this.header.DeducationScopes || this.header.AddScopes.length == 0 || this.header.DeducationScopes.length == 0) {
                        this.showError('Error Saving Data', "Must have at least one detail in both Additional and Deduction scopes");
                        return false;
                    }
                }

                // New rules when Cut Off BoQ is enabled
                if (this.header.Is_Additional == true && this.header.Cut_Off_BoQ) {
                    // case: no MC_Number => require at least one in AddScopes OR DeducationScopes
                    if (!this.header.MC_Number) {
                        const addScopesEmpty = !this.header.AddScopes || this.header.AddScopes.length == 0;
                        const dedScopesEmpty = !this.header.DeducationScopes || this.header.DeducationScopes.length == 0;
                        if (addScopesEmpty && dedScopesEmpty) {
                            this.showError('Error Saving Data', "Cannot Submit, Work Order without Link MC then required to entry manual the initial instruction");
                            return false;
                        }
                    }

                    // case: MC_Number present => require at least one in AddBoQ OR DeducationBoQ
                    if (this.header.MC_Number) {
                        const addBoQEmpty = !this.header.AddBoQ || this.header.AddBoQ.length == 0;
                        const dedBoQEmpty = !this.header.DeducationBoQ || this.header.DeducationBoQ.length == 0;
                        if (addBoQEmpty && dedBoQEmpty) {
                            this.showError('Error Saving Data', "Cannot Submit, Work Order with Link MC required to have deviation scope from MC. If MC doesn't have deviation then no need to create WO Addendum");
                            return false;
                        }
                    }
                }
           
            }else{
                if (!this.header.Reason && (this.header.Status == this.$APPROVAL_STATUS.FULL_RELEASE || this.header.Status == this.$APPROVAL_STATUS.WAITING_FOR_REVISION) ) {
                    return false;
                }
            }
            
            
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            var self = this;
          
            if(this.validationFromField())
                return;
           

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        validationFromPic()
        {
            if(!this.header.ReasonPicAppr || (!this.header.Usrnm_Head_User && this.is_head_user) || 
                (!this.header.Usrnm_Lead_Engineering && this.is_lead_engineering)  || (!this.header.Usrnm_Head_Project_Dept && this.is_head_dept) ||
                (!this.header.Usrnm_Head_User_Closing && this.is_head_user_closing) || (!this.header.Usrnm_Head_Project_Dept_Closing && this.is_head_dept_closing ||  (!this.header.Usrnm_PIC_AR_Closing && this.is_pic_creator_ar) || (!this.header.Usrnm_Lead_Engineering_Closing && this.is_lead_engineering_closing)))
            {
                return true;
            }
        },
        validationFromField(){
            //!this.header.No_SPK ||  || (!this.header.Usrnm_PIC_Engineering_Closing && this.is_pic_eng_closing) 
            if (!this.header.Department_Code || !this.header.Work_Group || !this.header.Company_Code || !this.header.Location_Code || !this.header.Company_Area_Id || 
                !this.header.Planned_Start_Date || !this.header.Duration|| (!this.header.No_SPR && this.header.Is_Tendering_Completed) ||
                (!this.header.WBS_Allocation && (this.header.Department_Code == this.$DEPARTMENT.PROJECT) &&(this.header.Work_Group == this.$WorkGroup.Project_Engineering || this.header.Work_Group == this.$WorkGroup.Project_Execution)) || !this.header.Work_Description 
                || (!this.header.Usrnm_Head_User && this.is_head_user) || 
                (!this.header.Usrnm_Lead_Engineering && this.is_lead_engineering)  || (!this.header.Usrnm_Head_Project_Dept && this.is_head_dept) ||
                (!this.header.Usrnm_Head_User_Closing && this.is_head_user_closing) || (!this.header.Usrnm_Head_Project_Dept_Closing && this.is_head_dept_closing ||  (!this.header.Usrnm_PIC_AR_Closing && this.is_pic_creator_ar) || (!this.header.Usrnm_Lead_Engineering_Closing && this.is_lead_engineering_closing) ||
                (!this.header.SPO_Date && this.header.Is_Tendering_Completed) || (!this.header.No_SPO && this.header.Is_Tendering_Completed) || (this.header.Is_Additional && !this.header.Work_Order_Id)
                || (!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.FULL_RELEASE)
                || (!this.header.Contract_Value && this.header.Is_Tendering_Completed)  || (this.header.Is_Tendering_Completed && !this.header.Currency) || (this.header.Is_Tendering_Completed && !this.header.Contract_Value) || (this.header.Is_Tendering_Completed && !this.header.Contractor_Code)
                )
                 ) {
                return true;
            }
            else
                return false;

        },
        validationFromAdoptSAP(){
            if(!this.header.No_SPO || !this.header.Item || !this.header.Company_Code){
                    this.showError('Error Adopt Data', "SPO No, SPO Item, and Company Code are required for Adopt data");
                    return true;
            }
            else
                return false;
        },
        onChangeCompany(e){
            this.header.Usrnm_Head_Project_Dept = null;
            this.header.Usrnm_Head_User = null;
            this.header.Usrnm_Head_User_Closing = null;
            this.header.Usrnm_Head_Project_Dept_Closing = null;
            this.header.Usrnm_PM_Closing = null;
            this.header.Usrnm_Lead_Engineering = null;
            this.header.Usrnm_PIC_Engineering_Closing = null;
            this.header.Usrnm_Lead_Engineering_Closing = null;
            this.header.Usrnm_PIC_AR_Closing = null;
            this.header.Contractor_Code = null;
            this.header.Currency = null;
            this.header.Contract_Value = null;
            this.header.WBS_Allocation = null;
            this.header.Is_Tendering_Completed = null;
            this.header.No_SPR = null;
            this.header.SPO_Date = null;
            this.header.No_SPO = null;
            this.header.Item = null;
            this.header.Item_SPR = null;
            this.header.Work_Description = null;
            this.header.No_SPK = null;
            this.header.Planned_Start_Date = null;
            this.header.Duration = 0;
            this.header.Company_Area_Id = null;
            if(e)
            {
                this.header.Active_SAP = e.Active_SAP;
            }

        },
        onChangeLocation(){
            this.header.Company_Area_Id = null;
            this.header.Company_Code = null;
            this.header.Usrnm_Head_Project_Dept = null;
            this.header.Usrnm_Head_User = null;
            this.header.Usrnm_Head_User_Closing = null;
            this.header.Usrnm_Head_Project_Dept_Closing = null;
            this.header.Usrnm_PM_Closing = null;
            this.header.Usrnm_Lead_Engineering = null;
            this.header.Usrnm_PIC_Engineering_Closing = null;
            this.header.Usrnm_Lead_Engineering_Closing = null;
            this.header.Usrnm_PIC_AR_Closing = null;
            this.header.Contractor_Code = null;
            this.header.Currency = null;
            this.header.Contract_Value = null;
            this.header.WBS_Allocation = null;
            this.header.Is_Tendering_Completed = null;
            this.header.No_SPR = null;
            this.header.SPO_Date = null;
            this.header.No_SPO = null;
            this.header.Item = null;
            this.header.Item_SPR = null;
            this.header.Work_Description = null;
            this.header.No_SPK = null;
            this.header.Planned_Start_Date = null;
            this.header.Duration = 0;
            this.header.Company_Area_Id = null;
            this.header.Active_SAP = null;
        },
        onChangeSPO(){
            if(this.header.Active_SAP)
            {
                this.header.No_SPR = null;
                this.header.Item_SPR = null;
                this.header.SPO_Date = null;
                this.header.Work_Description = null;
                this.header.No_SPK = null;
                this.header.Duration = 0;
                this.header.Contractor_Code = null;
                this.header.Currency = null;
                this.header.Contract_Value = null;
                this.header.WBS_Allocation = null;
                this.header.Adopt_SAP = false;
            }
        },
        onChangeContractor(){
            this.header.Usrnm_Head_Project_Dept = null;
            this.header.Usrnm_Head_User = null;
            this.header.Usrnm_Head_User_Closing = null;
            this.header.Usrnm_Head_Project_Dept_Closing = null;
            this.header.Usrnm_PM_Closing = null;
            this.header.Usrnm_Lead_Engineering = null;
            this.header.Usrnm_PIC_Engineering_Closing = null;
            this.header.Usrnm_Lead_Engineering_Closing = null;
            this.header.Usrnm_PIC_AR_Closing = null;
        },
        onChangeWorGroup(){
            if(this.header.Department_Code == this.$DEPARTMENT.PROJECT && (this.header.Work_Group == this.$WorkGroup.Project_Engineering || this.header.Work_Group == this.$WorkGroup.Project_Execution))
            {
                this.validateInput = true;
                this.header.Work_Description = null;
            }else{
                this.validateInput = false;
            }
            // this.header.Usrnm_Head_Project_Dept = null;
            // this.header.Usrnm_Head_User = null;
            // this.header.Usrnm_Head_User_Closing = null;
            // this.header.Usrnm_Head_Project_Dept_Closing = null;
            // this.header.Usrnm_PM_Closing = null;
            // this.header.Usrnm_Lead_Engineering = null;
            // this.header.Usrnm_PIC_Engineering_Closing = null;
            // this.header.Usrnm_Lead_Engineering_Closing = null;
            // this.Usrnm_PIC_AR_Closing = null;
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail1() {
            var newDetail = this.AddScope;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.AddScopes.push(det);
        },
        deleteDetail1(event) {
            if (event) {
                var detail = this.header.AddScopes[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.AddScopes.splice(this.header.AddScopes.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete1(event) {
            this.editDetail1(event.index);
        },
        editDetail1(index) {
            if (this.header && this.header.AddScopes) {
                let mode = this.header.AddScopes[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.AddScopes[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetail2() {
            var newDetail = this.DeducationScope;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.DeducationScopes.push(det);
        },
        deleteDetail2(event) {
            if (event) {
                var detail = this.header.DeducationScopes[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.DeducationScopes.splice(this.header.DeducationScopes.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete2(event) {
            this.editDetail2(event.index);
        },
        editDetail2(index) {
            if (this.header && this.header.DeducationScopes) {
                let mode = this.header.DeducationScopes[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.DeducationScopes[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileRemove1(files,data) {
                data.files_data1 = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data1.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
            data.files_data = [];
            for(var i = 0; i<event.files.length;i++){
                data.files_data.push(event.files[i]);
            }
        },
        onFileSelect1(event, data) {
            data.files_data1 = [];
            for(var i = 0; i<event.files.length;i++){
                data.files_data1.push(event.files[i]);
            }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_file/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
        onDownloadFile1(file){
            var self = this;
            this.$axios.get(this.url + "download_currently/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
        onDownloadFile2(file){
            var self = this;
            this.$axios.get(this.url + "download_previosly/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },
        onClickIsAdditional(){

            if(this.header.woType == "Main"){
                this.header.Is_Additional = false;
                this.header.Work_Order_Id = null;
            }else if(this.header.woType == "Addendum"){
                this.header.Is_Additional = true;
                this.header.Work_Order_Id = null;
            }

            // if(this.header.Is_Additional){
            //     //this.is_disabled_add = false;
            // }else{
            //     //this.is_disabled_add = true;
            //     this.header.Work_Order_Id = null;
            // }
        },
        onChangeWorkNumber(e){
            if(e){
                
                if(e.Work_Group == this.$WorkGroup.Project_Execution)
                    this.header.Work_Group = this.$WorkGroup.Project_Engineering;
                else 
                    this.header.Work_Group = e.Work_Group;

                //this.header.Work_Description = e.Work_Description;
                this.header.Company_Code = e.Company_Code;
                this.header.Company_Area_Id = e.Company_Area_Id;
                this.header.Cut_Off_BoQ = e.Cut_Off_BoQ;
                //this.header.Target_Date = e.Target_Date;
                //this.header.Duration = e.Duration;
                // this.header.WBS_Allocation = e.WBS_Allocation;
                // this.header.No_SPR = e.No_SPR;
                // this.header.No_SPO = e.No_SPO;
                // this.header.SPO_Date = e.SPO_Date;
                // this.header.No_SPK = e.No_SPK;
                //this.header.Usrnm_Head_User = e.Usrnm_Head_User;
                //this.header.Usrnm_Lead_Engineering = e.Usrnm_Lead_Engineering;
                //this.header.Usrnm_Head_Project_Dept = e.Usrnm_Head_Project_Dept;
                //this.header.Usrnm_PM_Closing = e.Usrnm_PM_Closing;
                //this.header.Usrnm_PIC_Engineering_Closing = e.Usrnm_PIC_Engineering_Closing;
                //this.header.Usrnm_Head_User_Closing = e.Usrnm_Head_User_Closing;
                //this.header.Usrnm_Head_Project_Dept_Closing = e.Usrnm_Head_Project_Dept_Closing;
                this.header.Wo_Number_Main = e.Wo_Number;
                //this.header.Planned_Start_Date = e.Planned_Start_Date;
                //this.header.Is_Tendering_Completed = e.Is_Tendering_Completed;
                this.header.Contractor_Code = e.Contractor_Code;
                //this.header.Item_SPR = e.Item_SPR;
                //this.header.Item = e.Item;
                //this.header.Contract_Value = e.Contract_Value;
                //this.header.Currency = e.Currency;
                this.header.MC_Number = null;
                this.header.Active_SAP = e.Active_SAP;
                this.header.Location_Code = e.Location_Code;
                //this.header.Usrnm_PIC_AR_Closing = e.Usrnm_PIC_AR_Closing;
                //this.header.Usrnm_Lead_Engineering_Closing = e.Usrnm_Lead_Engineering_Closing;
            }else{
                this.header.Work_Description = null;
                this.header.Work_Group = null;
                this.header.Company_Code = null;
                this.header.Company_Area_Id =null;
                this.header.Target_Date =null;
                this.header.Duration = null;
                this.header.WBS_Allocation = null;
                this.header.No_SPR = null;
                this.header.No_SPO = null;
                this.header.SPO_Date = null;
                this.header.No_SPK = null;
                this.header.Usrnm_Head_User = null;
                this.header.Usrnm_Lead_Engineering = null;
                this.header.Usrnm_Head_Project_Dept = null;
                this.header.Usrnm_PM_Closing = null;
                this.header.Usrnm_PIC_Engineering_Closing = null;
                this.header.Usrnm_Head_User_Closing = null;
                this.header.Usrnm_Head_Project_Dept_Closing = null;
                this.header.Wo_Number_Main = null;
                this.header.Planned_Start_Date = null;
                this.header.Is_Tendering_Completed = null;
                this.header.Usrnm_PIC_AR_Closing = null;
                this.header.Usrnm_Lead_Engineering_Closing = null;
                this.header.Is_Additional = false;
                this.header.Active_SAP = null;
                this.header.Location_Code = null;
            }
        }
    },
    computed:{
        category(){
            var result = "";
            if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Engineering)
                result = this.$CategoryWo.Engineering;
            //if engineering update to execution
            else if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Execution)
                result = this.$CategoryWo.Execution;
            else if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Drafter)
                result = this.$CategoryWo.Drafter;
            else if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Admin_Creator_AR)
                result = this.$CategoryWo.Admin_AR;
            else if (this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Engineering)
                result = this.$CategoryWo.NON_PROJECT_ENGINEERING;
            else if (this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Drafter)
                result = this.$CategoryWo.Drafter;
            else if (this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Admin_Creator_AR)
                result = this.$CategoryWo.Admin_AR;
        
            return result;
        },
        is_lead_engineering(){
            var result = this.category == this.$CategoryWo.Execution && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;
            
            result = this.listPicAppr1.filter(item => item.Approval_As == this.$UserLevel.LEAD_ENGINEERING).length > 0;

            return result;
        },
        is_lead_engineering_closing(){
            var result = this.category == this.$CategoryWo.Drafter || this.category == this.$CategoryWo.Engineering || this.category == this.$CategoryWo.Execution;
            result = this.listPicAppr2.filter(item => item.Approval_As == this.$UserLevel.LEAD_ENGINEERING).length > 0;
            return result;
        },
        is_head_user(){
            var result = this.category == this.$CategoryWo.Drafter && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Admin_AR && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Drafter && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT ||
                        this.category == this.$CategoryWo.Admin_AR && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT ||
                        this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;
            
            result = this.listPicAppr1.filter(item => item.Approval_As == this.$UserLevel.HEAD_USER).length > 0;
            
            return result;
            
        },
        is_head_dept(){
            var result = (this.category == this.$CategoryWo.Execution || this.category == this.$CategoryWo.Engineering) && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;
                 
            result = this.listPicAppr1.filter(item => item.Approval_As == this.$UserLevel.HEAD_PROJECT_DEPARTMENT).length > 0;

            return result;
        },
        is_pm_closing(){
            var result = (this.category == this.$CategoryWo.Execution || this.category == this.$CategoryWo.Engineering)  && this.header.Department_Code == this.$DEPARTMENT.PROJECT;
            result = this.listPicAppr2.filter(item => item.Approval_As == this.$UserLevel.PROJECT_MANAGER).length > 0;
            return result;
        },
        is_pic_eng_closing(){
            var result = this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;
            result = this.listPicAppr2.filter(item => item.Approval_As == this.$UserLevel.PIC_ENGINEERING).length > 0;
            return result;
        },
        is_head_user_closing(){
            var result = this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;
            result = this.listPicAppr2.filter(item => item.Approval_As == this.$UserLevel.HEAD_USER).length > 0;
            return result;
        },
        is_head_dept_closing(){
            var result = this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT || 
                        (this.category == this.$CategoryWo.Execution || this.category == this.$CategoryWo.Engineering)  && this.header.Department_Code == this.$DEPARTMENT.PROJECT;
            result = this.listPicAppr2.filter(item => item.Approval_As == this.$UserLevel.HEAD_PROJECT_DEPARTMENT).length > 0;
            return result;  
        },
        is_pic_creator_ar(){
            var result = this.category == this.$CategoryWo.Admin_AR && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT || 
                        this.category == this.$CategoryWo.Admin_AR && this.header.Department_Code == this.$DEPARTMENT.PROJECT;
            result = this.listPicAppr2.filter(item => item.Approval_As == this.$UserLevel.PIC_CREATOR_AR).length > 0;
            return result;
        },
        isUpdateWoCLosed(){
            let result = this.mode == this.$FORM_MODE_UPDATE_STATUS && this.$store.getters.getIsUpdateWo;
           return result;
        },
        isExecution(){
            let result = (this.category == this.$CategoryWo.Execution || this.category == this.$CategoryWo.Engineering) && this.header.Department_Code == this.$DEPARTMENT.PROJECT;
           return result;
        }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
    
        debugger;
        this.mainid = this.$route.query.mainid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
         this.getData();
    }
}
</script>
<style scoped>
.p-skeleton {
    height: 0 !important;
    display: none !important;
}

/* Table base styling */
::v-deep(.editable-cells-table) {
   font-size: 1rem;
}

::v-deep(.editable-cells-table .p-inputtext),
::v-deep(.editable-cells-table .p-inputnumber-input),
::v-deep(.editable-cells-table .p-inputtextarea) {
   font-size: 1rem;
   width: 100%;
}

::v-deep(.p-datatable .p-datatable-tbody > tr > td) {
   white-space: normal;
   word-wrap: break-word;
}

/* Textarea height */
::v-deep(.p-datatable .p-datatable-tbody > tr > td textarea) {
   min-height: 60px;
}

/* Row coloring based on mode status */
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created > td) {
   background-color: #c8e6c9 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover > td) {
   background-color: #a5d6a7 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited > td) {
   background-color: #fff9c4 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover > td) {
   background-color: #fff59d !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted > td) {
   background-color: #ffcdd2 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover > td) {
   background-color: #ef9a9a !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-hidden) {
   display: none;
}
</style>